/**
 * @prettier
 */

import React from 'react';
import cx from 'classnames';

import { ButtonV2 } from '@zola/zola-ui';

import styles from './styles.module.less';

const CustomizeCardButton = ({ handleCustomizeClick, disabled }) => {
  return (
    <ButtonV2
      className={cx(['btn-wide', styles.customizeCardButton])}
      onClick={handleCustomizeClick}
      disabled={disabled}
    >
      <span className="hidden-xs">Customize This Design</span>
      <span className="visible-xs">Customize Design</span>
    </ButtonV2>
  );
};

export default CustomizeCardButton;



// WEBPACK FOOTER //
// ./src/cards/components/ProductDetail/CustomizeCardButton/CustomizeCardButton.jsx